<script>
  import { scale } from "svelte/transition";
</script>

<div
  in:scale={{ duration: 100, opacity: 0.9, start: 0.9 }}
  class="uppercase font-medium space-y-4 mt-4 text-center"
>
  <slot />
</div>
